import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderIcon',
  props: {
    spinnerColor: { default: "white" }
  },
  setup(__props: any) {



const colorClasses = {
  white: "text-white",
  black: "text-black",
  brown: "text-brown",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] z-10 ml-auto", colorClasses[__props.spinnerColor]]),
    role: "status"
  }, null, 2))
}
}

})